<template>
  <div class="pie-wrapper" @click="$emit('click')">
    <div ref="myPie" class="pie-inner"></div>
    <!-- <div class="pie-num">{{ score }}</div> -->
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'pie',
  props: {
    pieData: {
      type: Array,
      default() {
        return [];
      },
    },
    score: [String, Number],
    radius: {
      type: Array,
      default() {
        return ['78%', '100%'];
      },
    },
    type: {
      type: String,
      default() {
        return 'pie';
      },
    },
  },
  data() {
    return {
      myChart: null
    };
  },
  watch: {
    score() {
      this.drawPie();
    },
    pieData() {
      this.drawPie();
    },
  },
  mounted: function () {
    this.drawPie();
  },
  methods: {
    drawPie() {
      if (this.myChart) {
        this.myChart.dispose();
      }
      // 基于准备好的dom，初始化echarts实例
      this.myChart = echarts.init(this.$refs.myPie);
      // document.getElementById('myPie')
      // 绘制图表
      this.myChart.setOption({
        title: !this.score ? null : {
          text: this.type === 'ratio' ? `${this.score}%` : this.score,
          left: 'center',
          top: 'center',
        },

        tooltip: {
          trigger: 'none',
        },

        series: [
          {
            type: 'pie',
            radius: this.radius,
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '40',
                fontWeight: 'bold',
              },
              scale: false,
            },

            data: this.score > 0 ? this.pieData : [],
          },
        ],
      });
    },
  },
};
</script>

<style lang="scss">
.pie-wrapper {
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;
  .pie-inner {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
  }
  .pie-num {
    font-size: 18px;
    color: #1a1a1a;
    font-weight: bold;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 12;
  }
}
</style>
